import BaseApi from './BaseApi'

class AgentApi extends BaseApi {
  createCompany (companyCreationObj) {
    return this.post('agent/contracts', companyCreationObj)
  }

  getContract (contractId) {
    return this.get(`agent/contract/${contractId}`)
  }
  subscribe (contractId, subscription) {
    return this.post(`/agent/contract/${contractId}/subscribe`, subscription)
  }
}

export default new AgentApi()
